import React from 'react';
import MatchesView from '../components/MatchesView';

const MatchesPage: React.FC = () => <MatchesView />;

export default MatchesPage;
